import { Dispatch, SetStateAction } from "react";
import type { BankTableRow } from "../../types/api";
import { Box, IconButton, Tooltip } from "@mui/material";
import moment from "moment";
import usePermission from "../../hooks/usePermission";
import Pagination from "../../components/Panigation";
import useTranslation from "../../hooks/traslation";


type Props = {
  open: boolean;
  openDelete: boolean;
  setOpenDelete: Dispatch<SetStateAction<boolean>>;
  setOpen: Dispatch<SetStateAction<boolean>>;
  setSelectedId: Dispatch<SetStateAction<string>>;
  name: string;
  rows: BankTableRow[];
  openDetails: boolean;
  setOpenDetails: Dispatch<SetStateAction<boolean>>;
  setName: Dispatch<SetStateAction<string>>;
  isLoading: boolean;
  handleEditClick: (row: BankTableRow) => void;
  setRows: Dispatch<SetStateAction<BankTableRow[]>>;
  handlePageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => void;
  setPage: Dispatch<SetStateAction<number>>;
  page: number;
  totalCount: number;
};

const BanksList = ({
  setOpen,
  setOpenDetails,
  setSelectedId,
  setName,
  setOpenDelete,
  rows,
  isLoading,
  handleEditClick,
  totalCount,
  handlePageChange,
  page,
  setPage,
}: Props) => {
  const translate = useTranslation();

  const { isEdit, isDelete } = usePermission({
    label: "Manage Banks",
    page_permission: "isView",
  });

  const itemsPerPage = 10;
  const totalPages = Math.ceil(totalCount / itemsPerPage);

  return (
    <>
      <div className="sorting_table">
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th>{translate?.globals?.name || "Name"}</th>
              <th>{translate?.main?.createdAt || "Created At"}</th>
              <th>{translate?.globals?.actions || "Actions"}</th>
            </tr>
          </thead>
          <tbody>
            {rows?.length ? (
              rows?.map((row: BankTableRow) => (
                <tr key={row._id}>
                  <td>{row?.name || ""}</td>
                  <td>
                    {row?.createdAt
                      ? moment(row.createdAt).format("DD MMM YYYY")
                      : "-"}
                  </td>
                  <td>
                    <div className="table_actions v2">
                      <Box>
                        <Tooltip title="View">
                          <IconButton
                            onClick={() => {
                              setOpenDetails(true);
                              setSelectedId(row?._id);
                              setName(row?.name ?? "");
                            }}
                          >
                            <img
                              src="/static/images/eye_icon.svg"
                              alt=""
                            />
                          </IconButton>
                        </Tooltip>
                      </Box>
                      {isEdit ? (
                        <Box>
                          <Tooltip title="Edit">
                            <IconButton
                              onClick={() => {
                                handleEditClick(row);
                              }}
                            >
                              <img
                                src="/static/images/edit2_icon.svg"
                                alt=""
                              />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      ) : null}

                      {isDelete ? (
                        <Box>
                          <Tooltip title="Delete">
                            <IconButton
                              onClick={() => {
                                setSelectedId(row?._id);
                                setOpenDelete(true);
                              }}
                            >
                              <img
                                src="/static/images/trash2_icon.svg"
                                alt=""
                              />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      ) : null}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={3}
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  {translate?.auth?.noDataFound || "No data found"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {totalCount > 0 ? (
          <Pagination
            setPage={setPage}
            module={rows}
            page={page}
            onPageChange={(newPage: number) => {
              setPage(newPage);
            }}
            totalPages={totalPages}
          />
        ) : null}
      </div>
    </>
  );
};

export default BanksList;
